interface PaginationControlsProps {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
  totalResults?: number;
  currentCount?: number;
}

export default function PaginationControls({ 
  hasMore, 
  loading, 
  onLoadMore, 
  totalResults, 
  currentCount 
}: PaginationControlsProps) {
  if (!hasMore && currentCount === 0) {
    return null;
  }

  return (
    <div className="mt-6 space-y-4">
      {/* Results Counter */}
      {totalResults && currentCount && (
        <div className="text-center">
          <span className="text-sm text-sepia-600 font-ui vintage-paper-subtle px-3 py-1 rounded-[15%]">
            Mostrando {currentCount} de {totalResults} resultados
          </span>
        </div>
      )}

      {/* Load More Button */}
      {hasMore && (
        <div className="text-center">
          <button
            onClick={onLoadMore}
            disabled={loading}
            className="vintage-paper-subtle text-sepia-900 hover:bg-sepia-200/70 px-6 py-3 text-sm font-ui transition-all duration-300 rounded-[15%] hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 mx-auto"
          >
            {loading ? (
              <>
                <div className="w-4 h-4 border-2 border-sepia-300 border-t-sepia-800 rounded-full animate-spin"></div>
                Cargando más...
              </>
            ) : (
              <>
                <i className="ri-add-line"></i>
                Cargar más noticias
              </>
            )}
          </button>
        </div>
      )}

      {/* End of Results Message */}
      {!hasMore && currentCount && currentCount > 0 && (
        <div className="text-center">
          <span className="text-sm text-sepia-600 font-ui vintage-paper-subtle px-3 py-1 rounded-[15%]">
            No hay más noticias para mostrar
          </span>
        </div>
      )}
    </div>
  );
}